export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const isSameDay = (data: any) => {
  const now = new Date().getTime();
  const claimedDate =
    new Date(data[0]?.timestamp).getUTCFullYear() +
    "-" +
    (new Date(data[0]?.timestamp).getUTCMonth() + 1) +
    "-" +
    new Date(data[0]?.timestamp).getUTCDate();

  return new Date(now).getTime() > new Date(claimedDate).getTime() + 86400000;
};

export const checkSameDayV2 = (timestamp: string) => {
  if (!timestamp) {
    return false;
  }

  const today = new Date();
  const time = new Date(timestamp);

  return (
    today.getUTCFullYear() === time.getUTCFullYear() &&
    today.getUTCMonth() === time.getUTCMonth() &&
    today.getUTCDate() === time.getUTCDate()
  );
};

export const checkSameDay = (data: any) => {
  if (!data?.length || !data[0] || !data[0].timestamp) {
    return false;
  }

  const date = new Date();
  const d = new Date(data[0].timestamp);
  return (
    date.getUTCFullYear() === d.getUTCFullYear() &&
    date.getUTCMonth() === d.getUTCMonth() &&
    date.getUTCDate() === d.getUTCDate()
  );
};

export const getMobileOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return "Android";
  } else if (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    return "iOS";
  }
  return "Other";
};

export const renderErrMessage = (errMessage: string) => {
  if (!errMessage) {
    return "Something went wrong";
  }
  return errMessage === "incomplete task" ? "Incomplete mission" : errMessage;
};

export const EGG_STATUS = {
  ON_MARKET: "on-market",
  BOUGHT: "bought",
  REMOVED: "removed",
};

export const MARKET_ITEM_STATUS = {
  ON_SALE: "on-sale",
  BOUGHT: "bought",
  REMOVED: "removed",
};

export const INVENTORY_STATUS = {
  ON_MARKET: "on-market",
  IN_INVENTORY: "in-inventory",
};

export const MARKET_HISTORY_STATUS = {
  ON_SALE: "on-sale",
  BOUGHT: "bought",
  REMOVED: "removed",
};

export const MARKET_HISTORY_STATUS_DISPLAY = {
  LISTING: "listing",
  SOLD: "sold",
  UNLISTED: "unlisted",
  BOUGHT: "bought",
};

export const MARKET_HISTORY_ACTION = {
  BUY: "buy",
  SELL: "sell",
  GIFT: "gift",
};

export const areEqual = (arr1: any[], arr2: any[]) => {
  // let N = arr1.length;
  // let M = arr2.length;

  // // If lengths of array are not equal means
  // // array are not equal
  // if (N != M) return false;

  // // Sort both arrays
  // arr1.sort();
  // arr2.sort();

  // // Linearly compare elements
  // for (let i = 0; i < N; i++) if (arr1[i] != arr2[i]) return false;

  // // If all elements were same.
  // return true;
  let result;
  // eslint-disable-next-line array-callback-return
  arr1?.map((item) => {
    // eslint-disable-next-line array-callback-return
    arr2?.map((item2) => {
      if (item?.id === item2?.id) {
        result = false;
        // return item
      } else {
        result = true;
        // return item
      }
    });
  });

  return result;
};

export const removeDuplicate = (arr: any) => {
  const map: Record<string, boolean> = {};

  return arr?.filter((value: any) => {
    if (!map[value.id]) {
      map[value.id] = true;
      return true;
    }

    return false;
  });
};

export const debounce = (fn: (arg0: any) => void, timer: number) => {
  let timeout: any;
  return function (args?: any) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(args);
    }, timer);
  };
};

export async function retry<T>(
  fn: () => Promise<T>,
  options: { retries: number; delay: number },
): Promise<T> {
  let lastError: Error | undefined;
  for (let i = 0; i < options.retries; i++) {
    try {
      return await fn();
    } catch (e) {
      if (e instanceof Error) {
        lastError = e;
      }
      await new Promise((resolve) => setTimeout(resolve, options.delay));
    }
  }
  throw lastError;
}

// export const getRandomInt = (min: number, max: number, exclusive: any) => {
//   const minCeiled = Math.ceil(min);
//   const maxFloored = Math.floor(max);
//   let result = Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
//   const duplicated = exclusive?.some((num: number) => num === result);
//   console.log("rs", duplicated, result);

//   if (duplicated) {
//     result = Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
//   }
//   return result;
// };

export function getRandomInt(min: number, max: number, exclude?: any[]) {
  let random;
  while (!random) {
    const x = Math.floor(Math.random() * (max - min + 1)) + min;
    if (exclude?.indexOf(x) === -1) random = x;
  }
  return random;
}

export const getRandomIntInclude = (min: number, max: number) => {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const telegramID = (process.env.REACT_APP_TELE_ID || "").replaceAll(
  "&",
  "%26",
);
// const telegram = window.Telegram?.WebApp;
// export const telegramID = telegram?.initData?.replaceAll("&", "%26");

export const getRandomPosition = (rect: DOMRect) => {
  return [
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 1,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 1,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 4,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 2,

      Seed3x3Left: rect.x + (rect.width / 10) * 0,
      Seed3x3Top: rect.y + (rect.height / 10) * 5,

      Tree2x3Left: rect.x + (rect.width / 10) * 7,
      Tree2x3Top: rect.y + rect.height / 10,

      Tree3x4Left: rect.x + (rect.width / 10) * 5,
      Tree3x4Top: rect.y + (rect.height / 10) * 6,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 7,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 6,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 4,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 7,

      Seed3x3Left: rect.x + (rect.width / 10) * 5,
      Seed3x3Top: rect.y + (rect.height / 10) * 2,

      Tree2x3Left: rect.x + (rect.width / 10) * 0,
      Tree2x3Top: rect.y + (rect.height / 10) * 6,

      Tree3x4Left: rect.x + (rect.width / 10) * 1,
      Tree3x4Top: rect.y + (rect.height / 10) * 1,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 0,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 7,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 2,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 1,

      Seed3x3Left: rect.x + (rect.width / 10) * 3,
      Seed3x3Top: rect.y + (rect.height / 10) * 4,

      Tree2x3Left: rect.x + (rect.width / 10) * 6,
      Tree2x3Top: rect.y + (rect.height / 10) * 8,

      Tree3x4Left: rect.x + (rect.width / 10) * 7,
      Tree3x4Top: rect.y + (rect.height / 10) * 1,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 6,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 1,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 0,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 6,

      Seed3x3Left: rect.x + (rect.width / 10) * 7,
      Seed3x3Top: rect.y + (rect.height / 10) * 4,

      Tree2x3Left: rect.x + (rect.width / 10) * 1,
      Tree2x3Top: rect.y + (rect.height / 10) * 1,

      Tree3x4Left: rect.x + (rect.width / 10) * 3,
      Tree3x4Top: rect.y + (rect.height / 10) * 4,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 5,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 1,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 3,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 4,

      Seed3x3Left: rect.x + (rect.width / 10) * 0,
      Seed3x3Top: rect.y + (rect.height / 10) * 0,

      Tree2x3Left: rect.x + (rect.width / 10) * 1,
      Tree2x3Top: rect.y + (rect.height / 10) * 7,

      Tree3x4Left: rect.x + (rect.width / 10) * 6,
      Tree3x4Top: rect.y + (rect.height / 10) * 5,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 7,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 6,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 4,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 1,

      Seed3x3Left: rect.x + (rect.width / 10) * 7,
      Seed3x3Top: rect.y + (rect.height / 10) * 0,

      Tree2x3Left: rect.x + (rect.width / 10) * 0,
      Tree2x3Top: rect.y + (rect.height / 10) * 2,

      Tree3x4Left: rect.x + (rect.width / 10) * 2,
      Tree3x4Top: rect.y + (rect.height / 10) * 5,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 7,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 7,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 3,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 7,

      Seed3x3Left: rect.x + (rect.width / 10) * 7,
      Seed3x3Top: rect.y + (rect.height / 10) * 0,

      Tree2x3Left: rect.x + (rect.width / 10) * 6,
      Tree2x3Top: rect.y + (rect.height / 10) * 4,

      Tree3x4Left: rect.x + (rect.width / 10) * 1,
      Tree3x4Top: rect.y + (rect.height / 10) * 1,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 1,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 4,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 3,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 7,

      Seed3x3Left: rect.x + (rect.width / 10) * 6,
      Seed3x3Top: rect.y + (rect.height / 10) * 5,

      Tree2x3Left: rect.x + (rect.width / 10) * 0,
      Tree2x3Top: rect.y + (rect.height / 10) * 1,

      Tree3x4Left: rect.x + (rect.width / 10) * 4,
      Tree3x4Top: rect.y + (rect.height / 10) * 0,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 0,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 7,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 3,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 5,

      Seed3x3Left: rect.x + (rect.width / 10) * 1,
      Seed3x3Top: rect.y + (rect.height / 10) * 1,

      Tree2x3Left: rect.x + (rect.width / 10) * 6,
      Tree2x3Top: rect.y + (rect.height / 10) * 1,

      Tree3x4Left: rect.x + (rect.width / 10) * 6,
      Tree3x4Top: rect.y + (rect.height / 10) * 6,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 7,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 7,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 4,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 5,

      Seed3x3Left: rect.x + (rect.width / 10) * 6,
      Seed3x3Top: rect.y + (rect.height / 10) * 1,

      Tree2x3Left: rect.x + (rect.width / 10) * 1,
      Tree2x3Top: rect.y + (rect.height / 10) * 1,

      Tree3x4Left: rect.x + (rect.width / 10) * 0,
      Tree3x4Top: rect.y + (rect.height / 10) * 5,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 2,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 7,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 6,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 2,

      Seed3x3Left: rect.x + (rect.width / 10) * 1,
      Seed3x3Top: rect.y + (rect.height / 10) * 3,

      Tree2x3Left: rect.x + (rect.width / 10) * 2,
      Tree2x3Top: rect.y + (rect.height / 10) * 0,

      Tree3x4Left: rect.x + (rect.width / 10) * 7,
      Tree3x4Top: rect.y + (rect.height / 10) * 5,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 1,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 5,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 3,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 7,

      Seed3x3Left: rect.x + (rect.width / 10) * 6,
      Seed3x3Top: rect.y + (rect.height / 10) * 7,

      Tree2x3Left: rect.x + (rect.width / 10) * 0,
      Tree2x3Top: rect.y + (rect.height / 10) * 2,

      Tree3x4Left: rect.x + (rect.width / 10) * 4,
      Tree3x4Top: rect.y + (rect.height / 10) * 1,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 7,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 7,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 4,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 8,

      Seed3x3Left: rect.x + (rect.width / 10) * 0,
      Seed3x3Top: rect.y + (rect.height / 10) * 4,

      Tree2x3Left: rect.x + (rect.width / 10) * 6,
      Tree2x3Top: rect.y + (rect.height / 10) * 0,

      Tree3x4Left: rect.x + (rect.width / 10) * 4,
      Tree3x4Top: rect.y + (rect.height / 10) * 3,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 6,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 0,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 1,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 1,

      Seed3x3Left: rect.x + (rect.width / 10) * 3,
      Seed3x3Top: rect.y + (rect.height / 10) * 4,

      Tree2x3Left: rect.x + (rect.width / 10) * 2,
      Tree2x3Top: rect.y + (rect.height / 10) * 8,

      Tree3x4Left: rect.x + (rect.width / 10) * 7,
      Tree3x4Top: rect.y + (rect.height / 10) * 3,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 8,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 1,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 1,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 1,

      Seed3x3Left: rect.x + (rect.width / 10) * 6,
      Seed3x3Top: rect.y + (rect.height / 10) * 6,

      Tree2x3Left: rect.x + (rect.width / 10) * 1,
      Tree2x3Top: rect.y + (rect.height / 10) * 6,

      Tree3x4Left: rect.x + (rect.width / 10) * 4,
      Tree3x4Top: rect.y + (rect.height / 10) * 0,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 0,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 1,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 1,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 6,

      Seed3x3Left: rect.x + (rect.width / 10) * 5,
      Seed3x3Top: rect.y + (rect.height / 10) * 5,

      Tree2x3Left: rect.x + (rect.width / 10) * 7,
      Tree2x3Top: rect.y + (rect.height / 10) * 2,

      Tree3x4Left: rect.x + (rect.width / 10) * 3,
      Tree3x4Top: rect.y + (rect.height / 10) * 0,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 7,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 1,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 8,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 7,

      Seed3x3Left: rect.x + (rect.width / 10) * 1,
      Seed3x3Top: rect.y + (rect.height / 10) * 1,

      Tree2x3Left: rect.x + (rect.width / 10) * 6,
      Tree2x3Top: rect.y + (rect.height / 10) * 4,

      Tree3x4Left: rect.x + (rect.width / 10) * 2,
      Tree3x4Top: rect.y + (rect.height / 10) * 5,
    },
    {
      Seed2x2x1Left: rect.x + (rect.width / 10) * 1,
      Seed2x2x1Top: rect.y + (rect.height / 10) * 1,

      Seed2x2x2Left: rect.x + (rect.width / 10) * 4,
      Seed2x2x2Top: rect.y + (rect.height / 10) * 2,

      Seed3x3Left: rect.x + (rect.width / 10) * 0,
      Seed3x3Top: rect.y + (rect.height / 10) * 5,

      Tree2x3Left: rect.x + (rect.width / 10) * 7,
      Tree2x3Top: rect.y + rect.height / 10,

      Tree3x4Left: rect.x + (rect.width / 10) * 5,
      Tree3x4Top: rect.y + (rect.height / 10) * 6,
    },
  ];
};

// const handleCheckLocation = useCallback(() => {
//   if (!map) return;

//   setIsLoading(true);

//   if (!navigator.geolocation) {
//     alert("Your browser does not support Geolocation API.");
//     setIsLoading(false);
//     return;
//   }

//   navigator.geolocation.getCurrentPosition(
//     (position) => {
//       const { latitude, longitude } = position.coords;

//       const userLocationMarker = L.divIcon({
//         html: `
//           <div class="relative flex justify-center items-center">
//             <div class="absolute inline-flex h-4 w-4 rounded-full bg-[#4593ee50] user-location"></div>
//             <div class="absolute inline-flex h-6 w-6 rounded-full bg-[#4593ee40] user-location"></div>
//             <div class="relative inline-flex h-4 w-4 rounded-full bg-[#4593ee] border-2 border-white"></div>
//           </div>
//         `,
//         className: "",
//         iconSize: [20, 20],
//         iconAnchor: [10, 10],
//       });

//       if (userLocationRef.current) {
//         map.removeLayer(userLocationRef.current);
//       }

//       const newMarker = L.marker([latitude, longitude], { icon: userLocationMarker }).addTo(map);
//       userLocationRef.current = newMarker;

//       map.setView([latitude, longitude], 17);
//       setIsLoading(false);
//     },
//     (error) => {
//       alert(`Unable to fetch your location: ${error.message}`);
//       setIsLoading(false);
//     },
//     {
//       enableHighAccuracy: true,
//       maximumAge: 1000,
//       timeout: 5000,
//     }
//   );
// }, [map]);

//  L.tileLayer(
//     "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
//     {
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
//       subdomains: "abcd",
//       maxZoom: 19,
//     },
//   ).addTo(mapInstance);
